import { render, staticRenderFns } from "./PopupNotice.vue?vue&type=template&id=9cf9ac42&"
import script from "./PopupNotice.vue?vue&type=script&lang=js&"
export * from "./PopupNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports